export const ADD_FIELD_FLOW = {
  ADD_NEW_FIELD: 'ADD_NEW_FIELD',
  ADD_PAYMENT_FIELD: 'ADD_PAYMENT_FIELD',
  ADD_NEW_ADI_FIELD: 'ADD_NEW_ADI_FIELD',
  DUPLICATE_FIELD: 'DUPLICATE_FIELD',
  DUPLICATE_ADI_FIELD: 'DUPLICATE_ADI_FIELD',
}
